module.exports = __webpack_public_path__ + "static/media/mail.8d6a46bf.svg";